import React from 'react';
import { Button } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

const StepNavigation = ({
  onNext,
  onBack,
  showBack = true,
  showNext = true,
  nextText = 'Continuar',
  backText = 'Voltar',
  loading = false,
  nextDisabled = false,
}) => {
  return (
    <div className="step-navigation">
      {showBack && (
        <Button
          type="default"
          onClick={onBack}
          icon={<ArrowLeftOutlined />}
          size="large"
          disabled={loading}
        >
          {backText}
        </Button>
      )}
      {showNext && (
        <Button
          type="primary"
          onClick={onNext}
          loading={loading}
          disabled={nextDisabled}
          size="large"
        >
          {nextText}
          {!loading && <ArrowRightOutlined />}
        </Button>
      )}
    </div>
  );
};

export default StepNavigation;
